module.exports = __webpack_public_path__ + "static/media/tradicional5.d2ec4556.webp";